package org.example.zone360.components


import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxSizing
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.disabled
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.onKeyUp
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.resize
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.style.LoginInputStyleDefault
import org.example.zone360.style.LoginInputStyleError
import org.example.zone360.style.LoginInputStyleFocus
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Constants.FONT_FAMILY
import org.example.zone360.utils.isValidEmail
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun InputField(
    errorText: String? = "",
    inputType: InputType<String>,
    placeHolder: String,
    id: String = "",
    isError: Boolean = false,
    marginBottom: CSSLengthNumericValue? = null,
    width: CSSLengthOrPercentageValue = 350.px,
    fixHeight: Boolean = false,
    maxLength: String = "524288",
    onValueChange: ((String) -> Unit)? = null,
    disabled: Boolean = false,
    onEnterPress: (() -> Unit)? = null, // ✅ NEW PARAM

) {
    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }
    var text by remember { mutableStateOf("") }
    var textError by remember { mutableStateOf("") }

    val sitePalette = ColorMode.current.toSitePalette()

    if (isError) {

        text = (document.getElementById(id) as HTMLInputElement).value
        if (text.isBlank()) {
            modifier = LoginInputStyleError.border(
                width = 2.px,
                style = LineStyle.Solid,
                color = sitePalette.textErrorColor.rgb
            )
            textError = errorText!!
        } else {
            if (inputType == InputType.Email) {
                if (!isValidEmail(email = text)) {
                    modifier = LoginInputStyleError.border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = sitePalette.textErrorColor.rgb
                    )
                    textError = "Please enter a valid email (e.g. name@domain.com)."
                } else {
                    modifier = LoginInputStyleDefault
                    textError = ""
                }
            } else {
                modifier = LoginInputStyleDefault
                textError = ""
            }
        }

    }


    Column(modifier = if (fixHeight) Modifier.height(80.px) else Modifier) {
        Input(
            type = inputType,
            attrs = modifier.id(id).margin(bottom = marginBottom ?: 20.px)
                .fillMaxWidth(width!!).height(45.px).padding(leftRight = 15.px)
                .backgroundColor(if (disabled) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.modalBackgroundColor.rgb)
                .color(if (disabled) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
                .fontFamily(FONT_FAMILY).fontSize(14.px).borderRadius(r = 5.px).outline(
                    width = 0.px, style = LineStyle.None, color = Colors.Transparent
                )
                .onKeyUp {
                    text = (document.getElementById(id) as HTMLInputElement).value
                    onValueChange?.invoke(text)
                    if (it.key == "Enter") {
                        onEnterPress?.invoke()
                    }

                    if (text.isBlank()) {
                        modifier = LoginInputStyleError.border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = sitePalette.textErrorColor.rgb
                        )
                        textError = errorText!!
                    } else {
                        if (inputType == InputType.Email && !isValidEmail(email = text)) {
                            modifier = LoginInputStyleError.border(
                                width = 2.px,
                                style = LineStyle.Solid,
                                color = sitePalette.textErrorColor.rgb
                            )
                            textError = "Please enter a valid email (e.g. name@domain.com)."
                        } else {
                            modifier = LoginInputStyleFocus
                            textError = ""
                        }
                    }
                }
                .onFocusOut {
                    text = (document.getElementById(id) as HTMLInputElement).value
                    onValueChange?.invoke(text)
                    if (text.isBlank()) {
                        modifier = LoginInputStyleError.border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = sitePalette.textErrorColor.rgb
                        )
                        textError = errorText!!
                    } else {
                        if (inputType == InputType.Email) {
                            if (!isValidEmail(email = text)) {
                                modifier = LoginInputStyleError
                                textError = "Please enter a valid email (e.g. name@domain.com)."
                            } else {
                                modifier = LoginInputStyleDefault
                                textError = ""
                            }
                        } else {
                            modifier = LoginInputStyleDefault
                            textError = ""
                        }


                    }


                }.onFocusIn {


                    modifier =
                        LoginInputStyleFocus


                }.onKeyUp {
                    text = (document.getElementById(id) as HTMLInputElement).value

                    if (text.isBlank()) {
                        modifier = LoginInputStyleError.border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = sitePalette.textErrorColor.rgb
                        )
                        textError = errorText!!
                    } else {
                        if (inputType == InputType.Email) {
                            if (!isValidEmail(email = text)) {
                                modifier = LoginInputStyleError.border(
                                    width = 2.px,
                                    style = LineStyle.Solid,
                                    color = sitePalette.textErrorColor.rgb
                                )
                                textError = "Please enter a valid email (e.g. name@domain.com)."
                            } else {
                                modifier = LoginInputStyleFocus
                                textError = ""
                            }
                        } else {
                            modifier = LoginInputStyleFocus
                            textError = ""
                        }


                    }

                }
                .toAttrs {
                    attr("placeholder", placeHolder)
                    attr("maxlength", maxLength)

                    when {
                        inputType == InputType.Password -> attr("autocomplete", "new-password")
                        inputType == InputType.Email -> attr("autocomplete", "email")
                        else -> attr("autocomplete", "off")
                    }
                }
        )
        FieldTitleTextNormal(
            marginTop = 3.px,
            fontSize = 11.px,
            text = textError,
            color = sitePalette.textErrorColor.rgb, onClick = {}
        )
    }
}

@Composable
fun TableInputField(
    placeHolder: String = "0.00",
    id: String = "",
    min: String = "0",
    step: String = "0.1",
    marginBottom: CSSLengthNumericValue? = null,
    disabled: Boolean = false,
    withRadius: Boolean = false,
    withoutDecimal: Boolean = false,
    onChange: () -> Unit,
) {
    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }

    val sitePalette = ColorMode.current.toSitePalette()

    modifier =
        if (disabled) modifier.border(
            width = 1.px,
            color = sitePalette.textFieldBorderColor.rgb,
            style = LineStyle.Solid
        ) else (if (modifier == LoginInputStyleFocus) LoginInputStyleFocus else LoginInputStyleDefault)


    Input(
        type = InputType.Text,
        attrs = modifier.id(id).margin(bottom = marginBottom ?: 20.px)
            .fillMaxWidth().height(45.px).padding(leftRight = 20.px)
            .backgroundColor(if (disabled) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.modalBackgroundColor.rgb)
            .color(if (disabled) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
            .fontFamily(FONT_FAMILY).fontSize(14.px)
            .borderRadius(r = if (withRadius) 5.px else 0.px).outline(
                width = 0.px, style = LineStyle.None, color = Colors.Transparent
            ).onFocusOut {
                modifier = LoginInputStyleDefault


            }.onFocusIn {
                modifier =
                    LoginInputStyleFocus
            }.onKeyDown {
                if (it.key != "Backspace") {

                    val regex = if (withoutDecimal) "[\\d]".toRegex() else "[\\d.]".toRegex()
                    val value =
                        (document.getElementById(id) as HTMLInputElement).value

                    if (regex.matches(it.key)) {
                        if (it.key == "." && value.contains(".")) {
                            it.preventDefault()
                        }
                    } else {
                        it.preventDefault()
                    }
                }

            }.onKeyUp {
                onChange()
            }.styleModifier {
                if (disabled) {
                    property("pointer-events", "none")
                }
                property("inputmode", "numeric")

            }
            .toAttrs {
                attr("placeholder", placeHolder)
                attr("min", min)
                attr("step", step)
            })
}

@Composable
fun OptionalInputField(
    value: String = "",
    onValueChange: (String) -> Unit = {},
    inputType: InputType<String> = InputType.Text,
    placeHolder: String = "",
    backgroundColor: CSSColorValue? = null,
    width: CSSLengthOrPercentageNumericValue = 100.px,
    height: CSSLengthNumericValue = 39.px,
    id: String = "",
    errorText: String? = "",
    isError: Boolean = false,
    textAlign: TextAlign = TextAlign.Start,
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    fontSize: CSSLengthNumericValue = 12.px,
    leftPadding: CSSLengthNumericValue = 15.px,
    rightPadding: CSSLengthNumericValue = 15.px,
    disabled: Boolean = false,
    onEnterPress: ((String) -> String)? = null,
    number: Boolean = false,
    isCardNumber: Boolean = false,
    isDateFormatMMYY: Boolean = false,
    onFocusChanged: ((Boolean) -> Unit)? = null,
    disallowedKeys: List<String> = emptyList(),
) {
    val isDateFocused by remember { mutableStateOf(false) }
    val effectiveType =
        if (inputType == InputType.Date && !isDateFocused) InputType.Text else inputType

    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }
    val sitePalette = ColorMode.current.toSitePalette()
    val resolvedBackgroundColor = backgroundColor
        ?: if (disabled) sitePalette.textFieldBorderColorDisabled.rgb
        else sitePalette.modalBackgroundColor.rgb


    modifier =
        if (disabled) modifier.border(width = 0.px) else (if (modifier == LoginInputStyleFocus) LoginInputStyleFocus else LoginInputStyleDefault)

    var text by remember { mutableStateOf("") }
    var textError by remember { mutableStateOf("") }

    if (isError) {

        text = (document.getElementById(id) as HTMLInputElement).value
        if (text.isBlank()) {
            modifier = LoginInputStyleError.border(
                width = 2.px,
                style = LineStyle.Solid,
                color = sitePalette.textErrorColor.rgb
            )
            textError = errorText!!
        } else {
            if (inputType == InputType.Email) {
                if (!isValidEmail(email = text)) {
                    modifier = LoginInputStyleError.border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = sitePalette.textErrorColor.rgb
                    )
                    textError = "Please enter a valid email (e.g. name@domain.com)."
                } else {
                    modifier = LoginInputStyleDefault
                    textError = ""
                }
            } else {
                modifier = LoginInputStyleDefault
                textError = ""
            }
        }

    }
    Column(modifier = Modifier.width(width)) {
        Input(
            type = effectiveType,
            attrs = modifier.id(id)
                .width(width)
                .disabled(disabled)
                .margin(bottom = marginBottom, right = marginRight, left = marginLeft)
                .height(height)
                .padding(left = leftPadding, right = rightPadding)
                .backgroundColor(resolvedBackgroundColor)
                .color(if (disabled) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
                .fontFamily(FONT_FAMILY).fontSize(fontSize)
                .borderRadius(r = 5.px)
                .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
                .textAlign(textAlign)
                .onFocusIn {
                    modifier = LoginInputStyleFocus
                    onFocusChanged?.invoke(true) // Notify focus in
                }
                .onFocusOut {
                    text = (document.getElementById(id) as HTMLInputElement).value
                    if (text.isBlank()) {
                        modifier = LoginInputStyleError.border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = sitePalette.textErrorColor.rgb
                        )
                        textError = errorText!!
                    } else {
                        if (inputType == InputType.Email) {
                            if (!isValidEmail(email = text)) {
                                modifier = LoginInputStyleError
                                textError = "Please enter a valid email (e.g. name@domain.com)."
                            } else {
                                modifier = LoginInputStyleDefault
                                textError = ""
                            }
                        } else {
                            modifier = LoginInputStyleDefault
                            textError = ""
                            onFocusChanged?.invoke(false) // Notify focus out
                        }


                    }

                }
                .onKeyDown { event ->
                    val allDisallowed = disallowedKeys

                    val allowedKeys = listOf("Backspace", "ArrowLeft", "ArrowRight", "Tab")

                    if ((isDateFormatMMYY || isCardNumber || number) && event.key !in allowedKeys) {
                        if (!event.key.matches(Regex("[0-9]"))) {
                            event.preventDefault()
                        }
                    }

                    if (event.key in allDisallowed) {
                        event.preventDefault()
                    }

                    if (event.key == "Enter") {
                        event.preventDefault()
                        if (onEnterPress != null) {
                            val newValue = onEnterPress(value)
                            onValueChange(newValue)
                        }
                        (document.getElementById(id) as? HTMLInputElement)?.blur()
                    }
                }
                .toAttrs {
                    if (inputType != InputType.Date || !isDateFocused) {
                        attr("placeholder", placeHolder)
                    }
                    if (number) {
                        attr("autocomplete", "off")
                    }
                    attr("value", value)
                    onInput { event ->
                        val input = event.nativeEvent.target.unsafeCast<HTMLInputElement>()
                        var raw = input.value.filter { it.isDigit() }

                        val formatted = when {
                            isCardNumber -> {
                                if (raw.length > 16) raw = raw.take(16)
                                raw.chunked(4).joinToString(" ")
                            }

                            isDateFormatMMYY -> {
                                if (raw.length > 4) raw = raw.take(4)
                                when (raw.length) {
                                    0, 1 -> raw
                                    2 -> "${raw}/"
                                    in 3..4 -> "${raw.substring(0, 2)}/${raw.substring(2)}"
                                    else -> raw
                                }
                            }

                            else -> input.value
                        }

                        onValueChange(formatted)
                        input.value = formatted // Force visual update
                    }


                    onKeyDown { event ->
                        if (event.key == "Enter") {
                            event.preventDefault()

                            if (onEnterPress != null) {
                                val newValue = onEnterPress(value)
                                onValueChange(newValue)
                            }

                            (document.getElementById(id) as? HTMLInputElement)?.blur() // Focus out
                        }
                    }
                }
        )
        FieldTitleTextNormal(
            marginTop = 3.px,
            fontSize = 11.px,
            text = textError,
            color = sitePalette.textErrorColor.rgb, onClick = {}
        )

    }
}

@Composable
fun ResizableTextAreaField(
    value: String = "",
    onValueChange: (String) -> Unit = {},
    placeholder: String = "",
    backgroundColor: Color? = null,
    width: CSSLengthOrPercentageNumericValue = 100.percent,
    minHeight: CSSLengthNumericValue = 80.px,
    maxHeight: CSSLengthNumericValue = 200.px,
    id: String = "",
    errorText: String? = "",
    isError: Boolean = false,
    fontSize: CSSLengthNumericValue? = null,
    leftPadding: CSSLengthNumericValue = 15.px,
    rightPadding: CSSLengthNumericValue = 15.px,
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    disabled: Boolean = false,
    resize: Boolean = true,
    maxCharLimit: Int? = null,
    isLoading: Boolean = false,
    onSaveClick: (() -> Unit)? = null,
    onCancelClick: (() -> Unit)? = null,
) {
    val sitePalette = ColorMode.current.toSitePalette()

    var textError by remember { mutableStateOf("") }
    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }

    val resolvedBackgroundColor = backgroundColor
        ?: if (disabled) sitePalette.textFieldBorderColorDisabled.rgb
        else sitePalette.modalBackgroundColor.rgb

    if (isError) {
        val inputText = (document.getElementById(id) as? HTMLTextAreaElement)?.value ?: ""
        if (inputText.isBlank()) {
            modifier =
                LoginInputStyleError.border(2.px, LineStyle.Solid, sitePalette.textErrorColor.rgb)
            textError = errorText ?: ""
        } else {
            modifier = LoginInputStyleDefault
            textError = ""
        }
    }

    val limitedValue = maxCharLimit?.let { value.take(it) } ?: value
    Column(modifier = Modifier.fillMaxWidth()) {
        Box(
            modifier = Modifier
                .width(width)
                .position(Position.Relative)
                .borderRadius(5.px)
                .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb)
                .backgroundColor(resolvedBackgroundColor)
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                TextArea(
                    attrs = modifier
                        .id(id)
                        .width(width)
                        .minHeight(minHeight)
                        .maxHeight(maxHeight)
                        .resize(if (resize) Resize.Vertical else Resize.None)
                        .padding(
                            left = leftPadding,
                            right = rightPadding,
                            top = 15.px,
                            bottom = 15.px   // ← normal padding, no extra space needed
                        )
                        .margin(bottom = marginBottom, left = marginLeft, right = marginRight)
                        .backgroundColor(Colors.Transparent)  // ← transparent, Box has the bg
                        .color(
                            if (disabled)
                                sitePalette.textFieldSupportiveTextColor.rgb
                            else sitePalette.textFieldTextColor.rgb
                        )
                        .fontSize(fontSize ?: 12.px)
                        .borderRadius(5.px)
                        .border(0.px, LineStyle.None, Colors.Transparent)  // ← remove textarea border
                        .boxSizing(BoxSizing.BorderBox)
                        .outline(0.px, LineStyle.None, Colors.Transparent)
                        .disabled(disabled)
                        .toAttrs {
                            attr("placeholder", placeholder)
                            attr("value", limitedValue)
                            onInput {
                                val newText = it.value.take(maxCharLimit ?: Int.MAX_VALUE)
                                onValueChange(newText)
                                (document.getElementById(id) as? HTMLTextAreaElement)?.value = newText
                            }
                        }
                )

                // ← Buttons sit BELOW textarea naturally, always visible at bottom
                if (onSaveClick != null || onCancelClick != null) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .backgroundColor(resolvedBackgroundColor)
                            .padding(right = 10.px, bottom = 10.px),
                        horizontalArrangement = Arrangement.End
                    ) {
                        if (onCancelClick != null) {
                            CommonButton(
                                text = "Cancel",
                                width = 80.px,
                                height = 32.px,
                                borderColor = sitePalette.primary.rgb,
                                backgroundColor = Colors.Transparent,
                                textSpanColor = sitePalette.primary.rgb,
                                onCLick = onCancelClick
                            )
                        }
                        CustomSpacer(10.px)
                        if (onSaveClick != null) {
                            CommonButton(
                                text = "Save",
                                width = 80.px,
                                height = 32.px,
                                isLoading = isLoading,
                                backgroundColor = sitePalette.primary.rgb,
                                textSpanColor = Colors.White,
                                onCLick = onSaveClick
                            )
                        }
                    }
                }
            }
        }

        if (textError.isNotEmpty()) {
            FieldTitleTextNormal(
                marginTop = 3.px,
                fontSize = 11.px,
                text = textError,
                color = sitePalette.textErrorColor.rgb,
                onClick = {}
            )
        }
    }

//    Column(modifier = Modifier.width(width)) {
//        Box(
//            modifier = Modifier
//                .width(width)
//                .position(Position.Relative)
//        ) {
//            Column(modifier = Modifier.fillMaxWidth()) {
//                TextArea(
//                    attrs = modifier
//                        .id(id)
//                        .width(width)
//                        .minHeight(minHeight)
//                        .maxHeight(maxHeight)
//                        .resize(if (resize) Resize.Vertical else Resize.None)
//                        .padding(
//                            left = leftPadding,
//                            right = rightPadding,
//                            top = 15.px,
//                            bottom = if (onSaveClick != null || onCancelClick != null) 55.px else 15.px // extra space for buttons inside
//                        )
//                        .margin(bottom = marginBottom, left = marginLeft, right = marginRight)
//                        .backgroundColor(resolvedBackgroundColor)
//                        .color(
//                            if (disabled)
//                                sitePalette.textFieldSupportiveTextColor.rgb
//                            else sitePalette.textFieldTextColor.rgb
//                        )
//                        .fontSize(fontSize ?: 12.px)
//                        .borderRadius(5.px)
//                        .boxSizing(BoxSizing.BorderBox)
//                        .outline(0.px, LineStyle.None, Colors.Transparent)
//                        .disabled(disabled)
//                        .toAttrs {
//                            attr("placeholder", placeholder)
//                            attr("value", limitedValue)
//
//                            onInput {
//                                val newText = it.value.take(maxCharLimit ?: Int.MAX_VALUE)
//                                onValueChange(newText)
//                                (document.getElementById(id) as? HTMLTextAreaElement)?.value =
//                                    newText
//                            }
//                        }
//                )
//            Row(
//                modifier = Modifier.fillMaxWidth()
//                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
//                    .position(Position.Absolute)
//                    .margin(right = 10.px, bottom = 10.px),
//                horizontalArrangement = Arrangement.End
//            ) {
//                if (onCancelClick != null) {
//                    CommonButton(
//                        text = "Cancel",
//                        width = 80.px,
//                        height = 32.px,
//                        borderColor = sitePalette.primary.rgb,
//                        backgroundColor = Colors.Transparent,
//                        textSpanColor = sitePalette.primary.rgb,
//                        onCLick = onCancelClick
//                    )
//                }
//
//                CustomSpacer(10.px)
//
//                if (onSaveClick != null) {
//                    CommonButton(
//                        text = "Save",
//                        width = 80.px,
//                        height = 32.px,
//                        isLoading = isLoading,
//                        backgroundColor = sitePalette.primary.rgb,
//                        textSpanColor = Colors.White,
//                        onCLick = onSaveClick
//                    )
//                }
//            }
//                }
//        }
//
//        // 🛑 Validation Error (if any)
//        if (textError.isNotEmpty()) {
//            FieldTitleTextNormal(
//                marginTop = 3.px,
//                fontSize = 11.px,
//                text = textError,
//                color = sitePalette.textErrorColor.rgb,
//                onClick = {}
//            )
//        }
//    }
}


@Composable
fun OptionalInputIconField(
    value: String = "",
    onValueChange: (String) -> Unit = {},
    inputType: InputType<String> = InputType.Text,
    placeHolder: String,
    width: CSSLengthOrPercentageNumericValue = 100.px,
    height: CSSLengthNumericValue = 39.px,
    id: String = "",
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    fontSize: CSSLengthNumericValue = 12.px,
    leftRightPadding: CSSLengthNumericValue = 10.px,
    disabled: Boolean = false,
    placeHolderAlignRight: Boolean = false,
    onEnterPress: ((String) -> String)? = null,
    number: Boolean = false,
    decimalLimit: Int? = null,
    onFocusChanged: ((Boolean) -> Unit)? = null,
    leadingIcon: (@Composable (() -> Unit))? = null,  // ✅ New
    trailingIcon: (@Composable (() -> Unit))? = null,  // ✅ New
) {
    var isDateFocused by remember { mutableStateOf(false) }
    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }

    val effectiveType =
        if (inputType == InputType.Date && !isDateFocused) InputType.Text else inputType
    val sitePalette = ColorMode.current.toSitePalette()

    modifier =
        if (disabled) modifier.border(width = 0.px) else (if (modifier == LoginInputStyleFocus) LoginInputStyleFocus else LoginInputStyleDefault)

    Row(
        modifier = Modifier
            .width(width)
            .height(height)
            .margin(bottom = marginBottom, right = marginRight, left = marginLeft)
            .backgroundColor(if (disabled) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.modalBackgroundColor.rgb)
            .borderRadius(5.px)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = if (disabled) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.textFieldBorderColor.rgb
            )
            .alignItems(AlignItems.Center)
            .padding(leftRight = leftRightPadding)
    ) {
        leadingIcon?.invoke()

        Input(
            type = effectiveType,
            attrs = modifier
                .id(id)
                .disabled(disabled)
                .width(80.percent)
                .color(if (disabled) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
                .backgroundColor(Colors.Transparent) // Transparent to avoid duplicate bg
                .border(width = 0.px)
                .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
                .padding(8.px)
                .fontSize(fontSize)
                .textAlign(if (placeHolderAlignRight) TextAlign.End else TextAlign.Start)
                .onFocusIn {
                    if (inputType == InputType.Date) isDateFocused = true
                    modifier = LoginInputStyleFocus
                    onFocusChanged?.invoke(true)
                }
                .onFocusOut {
                    if (inputType == InputType.Date && value.isEmpty()) isDateFocused = false
                    modifier = LoginInputStyleDefault
                    onFocusChanged?.invoke(false)
                }
                .onKeyDown {
                    if (number) {
                        val allowedKeys =
                            listOf("Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete")
                        val operatorKeys = listOf("+", "-", "*", "/") // If needed
                        val digitRegex = Regex("[0-9]")
                        val inputField = document.getElementById(id) as HTMLInputElement
                        val currentValue = inputField.value
                        val key = it.key

                        // ✅ Allow navigation and system keys
                        if (key in allowedKeys) return@onKeyDown

                        // ✅ Allow digits
                        if (digitRegex.matches(key)) {
                            // ✅ If there's a decimal limit, enforce it
                            val decimalLimit1 = decimalLimit ?: 2 // nullable Int?
                            if (currentValue.contains(".")) {
                                val decimalIndex = currentValue.indexOf(".")
                                val afterDecimal = currentValue.substring(decimalIndex + 1)
                                if ((inputField.selectionStart
                                        ?: 0) > decimalIndex && afterDecimal.length >= decimalLimit1
                                ) {
                                    it.preventDefault()
                                    return@onKeyDown
                                }
                            }
                            return@onKeyDown
                        }

                        // ✅ Allow only one "." in the middle of the number
                        if (key == ".") {
                            if (
                                currentValue.contains(".") || // Already has a decimal
                                currentValue.isEmpty() || // Cannot start with "."
                                (inputField.selectionStart == 0)  // Cannot start with "."

                            ) {
                                it.preventDefault()
                            }
                            return@onKeyDown
                        }

                        // ✅ Allow operators if needed
                        if (key in operatorKeys) {
                            val lastChar = currentValue.lastOrNull()?.toString()
                            if (currentValue.isEmpty() || lastChar in operatorKeys) {
                                it.preventDefault()
                            }
                            return@onKeyDown
                        }

                        // ❌ Block everything else
                        it.preventDefault()
                    }
                }
                .styleModifier {
                    property("font-family", FONT_FAMILY)
                }
                .toAttrs {
                    if (inputType != InputType.Date || !isDateFocused) {
                        attr("placeholder", placeHolder)
                    }
                    attr("value", value)
                    if (number) {
                        attr("autocomplete", "off")
                    }
                    onInput { event -> onValueChange(event.value) }

                    onKeyDown { event ->
                        if (event.key == "Enter") {
                            event.preventDefault()
                            if (onEnterPress != null) {
                                val value1 =
                                    (document.getElementById(id) as? HTMLInputElement)?.value ?: ""
                                val newValue = onEnterPress(value1)
                                onValueChange(newValue)
                            }
                            (document.getElementById(id) as? HTMLInputElement)?.blur()
                        }
                    }
                }
        )

        // ✅ Trailing icon (e.g., clear text button)
        trailingIcon?.invoke()
    }
}

@Composable
fun CountOptionalInputField(
    value: String = "",
    onValueChange: (String) -> Unit = {},
    inputType: InputType<*>,
    placeHolder: String,
    width: CSSLengthOrPercentageNumericValue = 100.px,
    height: CSSLengthNumericValue = 39.px,
    id: String = "",
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    fontSize: CSSLengthNumericValue = 12.px,
    disabled: Boolean = false,
    placeHolderAlignRight: Boolean = false,
    onEnterPress: ((String) -> String)? = null,
    number: Boolean = false,
    isPhone: Boolean = false, // ✅ New phone number toggle
    disableButKeepStyle: Boolean = false,
    onFocusChanged: ((Boolean) -> Unit)? = null,
    noNegative: Boolean = false,
) {
    var isDateFocused by remember { mutableStateOf(false) }

    val effectiveType =
        if (inputType == InputType.Date && !isDateFocused) InputType.Text else inputType

    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }
    val sitePalette = ColorMode.current.toSitePalette()


    modifier = if (disabled && !disableButKeepStyle) {
        modifier.border(width = 0.px)
    } else {
        if (modifier == LoginInputStyleFocus) LoginInputStyleFocus else LoginInputStyleDefault
    }

    Input(
        type = effectiveType,
        attrs = modifier.id(id).width(width).disabled(disabled)
            .margin(bottom = marginBottom, right = marginRight, left = marginLeft).height(height)
            .padding(leftRight = 15.px)
            .backgroundColor(if (disabled && !disableButKeepStyle) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.modalBackgroundColor.rgb)
            .color(if (disabled && !disableButKeepStyle) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
            .fontSize(fontSize).borderRadius(r = 5.px)
            .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
            .textAlign(if (placeHolderAlignRight) TextAlign.End else TextAlign.Start)
            .onFocusIn {
                if (inputType == InputType.Date) isDateFocused = true
                modifier = LoginInputStyleFocus
                onFocusChanged?.invoke(true)
            }
            .onFocusOut {
                if (inputType == InputType.Date && value.isEmpty()) isDateFocused = false
                modifier = LoginInputStyleDefault
                onFocusChanged?.invoke(false)
            }
            .onKeyDown {
                val allowedControlKeys =
                    listOf("Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete")

                if (isPhone) {
                    if (it.key !in allowedControlKeys && !it.key.matches(Regex("\\d"))) {
                        it.preventDefault()
                    }

                    // Prevent deleting '+' at start
                    val inputField = document.getElementById(id) as? HTMLInputElement
                    if (it.key == "Backspace" && inputField?.selectionStart == 0 && inputField.value.startsWith(
                            "+"
                        )
                    ) {
                        it.preventDefault()
                    }
                } else if (number && noNegative) {
                    if (it.key !in allowedControlKeys) {
                        val regex = Regex("[0-9]")
                        if (!regex.matches(it.key)) {
                            it.preventDefault()
                        } else {
                            // ✅ prevent '0' as first character
                            val inputField = document.getElementById(id) as? HTMLInputElement
                            if (it.key == "0" && (inputField?.value?.isEmpty() == true)) {
                                it.preventDefault()
                            }
                        }
                    }
                } else if (number) {
                    if (it.key !in allowedControlKeys) {
                        val regex = Regex("[0-9]")
                        if (!regex.matches(it.key)) {
                            it.preventDefault()
                        }
                    }
                }
            }.styleModifier {
                property("font-family", FONT_FAMILY)
            }
            .toAttrs {
                if (inputType != InputType.Date || !isDateFocused) {
                    attr("placeholder", placeHolder)
                }

                if (number) {
                    attr("autocomplete", "off")
                }
                attr("value", value)
                // ✅ enforce noNegative here
                onInput { event ->
                    val input = event.nativeEvent.target.unsafeCast<HTMLInputElement>()
                    var newValue = input.value

                    if (number && noNegative) {
                        val parsed = newValue.toDoubleOrNull()
                        if (parsed != null && parsed < 1) {
                            newValue = "1"
                        }
                    }

                    if (isPhone) {
                        val raw = input.value.filter { it.isDigit() }
                        newValue = if (raw.length <= 10) {
                            if (raw.length < 10) raw
                            else "(${raw.substring(0, 3)}) ${raw.substring(3, 6)}-${
                                raw.substring(6, 10)
                            }"
                        } else {
                            val prefix = raw.substring(0, raw.length - 10)
                            val last10 = raw.takeLast(10)
                            "+$prefix (${last10.substring(0, 3)}) ${
                                last10.substring(3, 6)
                            }-${last10.substring(6, 10)}"
                        }
                    }

                    onValueChange(newValue)
                    input.value = newValue
                }


                onKeyDown { event ->
                    if (event.key == "Enter") {
                        event.preventDefault()
                        if (onEnterPress != null) {
                            val value1 =
                                (document.getElementById(id) as? HTMLInputElement)?.value ?: ""
                            val newValue = onEnterPress(value1)
                            onValueChange(newValue)
                        }
                        (document.getElementById(id) as? HTMLInputElement)?.blur()
                    }
                }
            })
}

@Composable
fun DateTimePickerInputField(
    value: String,
    placeHolder: String,
    onValueChange: (String) -> Unit,
    inputType: InputType<String> = InputType.Text,
    width: CSSLengthOrPercentageNumericValue = 100.px,
    height: CSSLengthOrPercentageNumericValue = 45.px,
    id: String, // ✅ make it required
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    fontSize: CSSLengthNumericValue = 14.px,
    disabled: Boolean = false,
    disableButKeepStyle: Boolean = false,
    placeHolderAlignRight: Boolean = false,
) {
    val sitePalette = ColorMode.current.toSitePalette()

    var isFocused by remember { mutableStateOf(false) }
    var text by remember(value) { mutableStateOf(value) }

    // ✅ prevents stale lambda issues during recomposition
    val onValueChangeState by rememberUpdatedState(onValueChange)

    val currentModifier = when {
        disabled && !disableButKeepStyle -> LoginInputStyleDefault.border(width = 0.px)
        isFocused -> LoginInputStyleFocus
        else -> LoginInputStyleDefault
    }

    Input(
        type = inputType,
        attrs = currentModifier
            .id(id)
            .width(width)
            .disabled(disabled)
            .margin(bottom = marginBottom, right = marginRight, left = marginLeft)
            .height(height)
            .padding(leftRight = 12.px)
            .backgroundColor(
                if (disabled && !disableButKeepStyle)
                    sitePalette.textFieldBorderColorDisabled.rgb
                else
                    sitePalette.modalBackgroundColor.rgb
            )
            .color(
                if (disabled && !disableButKeepStyle)
                    sitePalette.textFieldSupportiveTextColor.rgb
                else
                    sitePalette.textFieldTextColor.rgb
            )
            .fontSize(fontSize)
            .borderRadius(r = 5.px)
            .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
            .textAlign(if (placeHolderAlignRight) TextAlign.End else TextAlign.Start)
            .onFocusIn { isFocused = true }
            .onFocusOut { isFocused = false }
            .styleModifier { property("font-family", FONT_FAMILY) }
            .toAttrs {
                attr("placeholder", placeHolder)
                attr("data-input", "")
                value(text)
                onInput { event ->
                    text = event.value
                    onValueChangeState(event.value)
                }
            }
    )
    DisposableEffect(Unit) {
        val timeoutId = window.setTimeout({
            val element = document.getElementById(id) as? org.w3c.dom.HTMLInputElement
            if (element != null) {

                val kotlinCallback = { s: String ->
                    text = s
                    onValueChangeState(s)
                }

                js(
                    """
                (function(el, defaultDate, cb){
                    if (typeof flatpickr === 'undefined') return;

                    if (el._flatpickr) {
                        el._flatpickr.destroy();
                    }

                    // 🔥 detect modal / safe container
                    var container =
                        el.closest('[role="dialog"], .modal, .popup') || document.body;

                    var fp = flatpickr(el, {
                        dateFormat: 'Y-m-d H:i',
                        enableTime: true,
                        allowInput: false,
                        clickOpens: true,
                        defaultDate: defaultDate,

                        appendTo: container,
                        position: 'auto',

                        onReady: function(_, __, instance) {
                            // 🔥 force z-index (modal safe)
                            instance.calendarContainer.style.zIndex = '2147483647';

                            // 🔥 mobile positioning fix
                            if (window.innerWidth <= 768) {
                                var c = instance.calendarContainer;
                                c.style.position = 'fixed';
                                c.style.left = '50%';
                                c.style.bottom = '20px';
                                c.style.top = 'auto';
                                c.style.transform = 'translateX(-50%)';
                            }
                        },

                        onOpen: function(selectedDates, dateStr, instance) {
                            if (selectedDates.length === 0) {
                                instance.jumpToDate(new Date());
                            }
                            // 🔥 force reposition after layout settles
                            requestAnimationFrame(function () {
                                instance.positionCalendar();
                            });
                        },

                        onChange: function(selectedDates, dateStr) {
                            el.value = dateStr;
                            cb(dateStr);
                        }
                    });

                    // 🔥 recalc on resize / orientation change
                    window.addEventListener('resize', function () {
                        if (fp && fp.isOpen) {
                            fp.positionCalendar();
                        }
                    });

                })
                """
                )(element, value, kotlinCallback)
            }
        }, 0)

        onDispose {
            window.clearTimeout(timeoutId)
            js(
                """
            (function(id){
                var el = document.getElementById(id);
                if (el && el._flatpickr) {
                    el._flatpickr.destroy();
                }
            })
            """
            )(id)
        }
    }


//    DisposableEffect(Unit) {
//        // ✅ schedule init but cancel it on dispose
//        val timeoutId = window.setTimeout({
//            val element = document.getElementById(id) as? org.w3c.dom.HTMLInputElement
//            if (element != null) {
//                // expose a callback for JS to call safely
//                // (Kotlin/JS interop via dynamic)
//                val kotlinCallback = { s: String ->
//                    text = s
//                    onValueChangeState(s)
//                }
//
//                js(
//                    """
//                    (function(el, defaultDate, cb){
//                        if (typeof flatpickr === 'undefined') return;
//
//                        // destroy existing instance if any
//                        if (el._flatpickr) { el._flatpickr.destroy(); }
//
//                        flatpickr(el, {
//                            dateFormat: 'Y-m-d H:i',
//                            allowInput: false,
//                            clickOpens: true,
//                            enableTime: true,
//                            defaultDate: defaultDate,
//                            onOpen: function(selectedDates, dateStr, instance) {
//                                if (selectedDates.length === 0) {
//                                    instance.jumpToDate(new Date());
//                                }
//                            },
//                            onChange: function(selectedDates, dateStr, instance) {
//                                // ✅ no synthetic event dispatch
//                                el.value = dateStr;
//                                cb(dateStr);
//                            }
//                        });
//                    })
//                    """
//                )(element, value, kotlinCallback)
//            }
//        }, 0)
//
//        onDispose {
//            window.clearTimeout(timeoutId)
//            js(
//                """
//                (function(id){
//                    var el = document.getElementById(id);
//                    if (el && el._flatpickr) {
//                        el._flatpickr.destroy();
//                    }
//                })
//                """
//            )(id)
//        }
//    }
}





